"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saltHashEmail = void 0;
const sha256Salt_1 = require("./sha256Salt");
const saltHashEmail = (email) => (0, sha256Salt_1.sha256Salt)(email.toLowerCase(), 'a7c8d80d-c89d-4921-b794-67d3c4700122');
exports.saltHashEmail = saltHashEmail;
//# sourceMappingURL=saltHashEmail.js.map